import React, { useEffect, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import * as ROUTES from "../constants/routes";
import "../sass/news-header.scss";
import { fetchJson } from "./newsApi";

function NewsHeader() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    async function loadCategories() {
      try {
        setLoading(true);
        setError("");

        const data = await fetchJson("/categories?populate=*");

        if (!cancelled) {
          setCategories(data?.data || []);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || "Unable to load news categories.");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    loadCategories();

    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return (
      <div className="news-container">
        <div className="news-status" role="status">
          <span className="news-status-spinner" aria-hidden="true" />
          <p>Loading Articles...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="news-container">
        <div className="news-status news-status--error" role="alert">
          <p>Error: {error}</p>
        </div>
      </div>
    );
  }

  return (
    // NOTE: deliberately NOT <main>. This component is a layout shell whose
    // <Outlet/> children (News / NewsCategory) each render their own <main>.
    // Only one <main> per document is valid, so the shell stays a plain
    // container and the child owns the landmark.
    <div className="news-header">
      <section className="title">
        <div className="title-left">
          <h1>G&amp;Y News</h1>
        </div>
      </section>

      <nav className="news-header-nav" aria-label="News categories">
        {categories.map((category) => (
          <NavLink
            key={category.id}
            to={`/${ROUTES.NEWS}/${ROUTES.NEWS_CATEGORY}/${category.id}`}
            className="category-text"
          >
            {category.attributes?.name}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}

export default NewsHeader;
